export interface ChatMessage {
  id: string;
  sender: 'user' | 'admin';
  text: string;
  timestamp: string;
  read: boolean;
}

export interface ChatConversation {
  id: string;
  userName: string;
  messages: ChatMessage[];
  lastActivity: string;
}

export const seedChatConversations: ChatConversation[] = [
  {
    id: 'session-demo-001',
    userName: 'Kwame Thomas',
    lastActivity: '2026-03-22T08:45:00',
    messages: [
      {
        id: 'm1',
        sender: 'user',
        text: 'Hey, my order SDG-20861 has been pending for a while. Any update?',
        timestamp: '2026-03-22T08:40:00',
        read: true,
      },
      {
        id: 'm2',
        sender: 'admin',
        text: 'Hi Kwame! Let me check that for you right now.',
        timestamp: '2026-03-22T08:42:00',
        read: true,
      },
      {
        id: 'm3',
        sender: 'admin',
        text: 'Your order is being prepared and a rider will pick it up shortly. Estimated arrival in 20 minutes!',
        timestamp: '2026-03-22T08:43:00',
        read: true,
      },
      {
        id: 'm4',
        sender: 'user',
        text: 'Great, thanks for the update!',
        timestamp: '2026-03-22T08:45:00',
        read: true,
      },
    ],
  },
  {
    id: 'session-demo-002',
    userName: 'Priya Ramkhelawan',
    lastActivity: '2026-03-22T07:30:00',
    messages: [
      {
        id: 'm5',
        sender: 'user',
        text: 'Do you have El Dorado 15yr in stock? I only see 12yr on the menu.',
        timestamp: '2026-03-22T07:25:00',
        read: true,
      },
      {
        id: 'm6',
        sender: 'admin',
        text: 'Hi Priya! Unfortunately the 15yr is currently out of stock. We expect a restock by end of the week. Can I note you down to be notified when it arrives?',
        timestamp: '2026-03-22T07:28:00',
        read: true,
      },
      {
        id: 'm7',
        sender: 'user',
        text: 'Yes please, that would be amazing!',
        timestamp: '2026-03-22T07:30:00',
        read: false,
      },
    ],
  },
  {
    id: 'session-demo-003',
    userName: 'Deon Clarke',
    lastActivity: '2026-03-21T22:10:00',
    messages: [
      {
        id: 'm8',
        sender: 'user',
        text: 'What time do you stop taking orders tonight?',
        timestamp: '2026-03-21T22:05:00',
        read: true,
      },
      {
        id: 'm9',
        sender: 'admin',
        text: 'We accept orders until midnight, Sunday through Thursday, and 1 AM on Fridays and Saturdays. You have time!',
        timestamp: '2026-03-21T22:07:00',
        read: true,
      },
      {
        id: 'm10',
        sender: 'user',
        text: 'Perfect, placing my order now.',
        timestamp: '2026-03-21T22:10:00',
        read: true,
      },
    ],
  },
];
